/**
 * Constants optionally passed as parameter in onToolChange callback
 */
export const ENABLED_PROP = 'enabled';
export const ID_PROP = 'id';